import { db } from '../firebase';
import firebase from '../firebase';

const PAGE_SIZE = 50;

export const getFeedbacks = async ({ page = 1, pageSize = 20 } = {}) => {
  const snapshot = await db.collection('feedbacks').orderBy('createdAt', 'desc').get();
  const allFeedbacks = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  const total = allFeedbacks.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const validPage = Math.max(1, Math.min(page, totalPages));
  const startIndex = (validPage - 1) * pageSize;
  const items = allFeedbacks.slice(startIndex, startIndex + pageSize);
  return { items, total, totalPages, page: validPage, pageSize };
};

export const getPrevFeedbacks = async () => {
  return { items: [] };
};

export const updateFeedback = async (id, data, feedbackDetails = null) => {
  await db.collection('feedbacks').doc(id).update({
    ...data,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  });

  // If this update contains an admin reply, send a notification to the user!
  if (data.adminReply && data.adminReply.trim()) {
    try {
      let targetUserId = feedbackDetails?.userId;
      let userName = feedbackDetails?.userName;
      let userEmail = feedbackDetails?.userEmail;

      if (!targetUserId) {
        const doc = await db.collection('feedbacks').doc(id).get();
        if (doc.exists) {
          const docData = doc.data();
          targetUserId = docData.userId;
          userName = docData.userName;
          userEmail = docData.userEmail;
        }
      }

      if (targetUserId) {
        const replySnippet = data.adminReply.trim().length > 180
          ? data.adminReply.trim().substring(0, 177) + '...'
          : data.adminReply.trim();

        const notifDoc = {
          title: 'Reply to your feedback',
          body: replySnippet,
          imageUrl: null,
          actionUrl: '/feedback',
          buttonText: 'View Reply',
          data: {
            type: 'feedback_reply',
            feedbackId: id,
            actionUrl: '/feedback',
          },
          targetUserId: targetUserId,
          targetUserName: userName || 'User',
          targetUserEmail: userEmail || '',
          isDirect: true,
          status: 'sent',
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          sentCount: 1,
        };

        const docRef = await db.collection('notifications').add(notifDoc);

        // Also add to user private notification subcollection
        try {
          await db.collection('users').doc(targetUserId).collection('notifications').doc(docRef.id).set({
            ...notifDoc,
            id: docRef.id,
          });
        } catch (subErr) {
          console.warn('Could not add to user subcollection:', subErr);
        }
      }
    } catch (notifErr) {
      console.warn('Failed to send notification for feedback reply:', notifErr);
    }
  }
};

export const getFeedbackById = async (id) => {
  const doc = await db.collection('feedbacks').doc(id).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
};

export const getUnreadFeedbackCount = async () => {
  const snapshot = await db.collection('feedbacks').where('acknowledged', '==', false).get();
  return snapshot.size;
};

